import { formatBRL } from 'dashboard/helper/lais/currency';

const temperatureLabel = (t, temperature) => {
  switch (temperature) {
    case 'frio':
      return t('REAL_ESTATE_BROKER_INVESTMENT.TEMPERATURES.FRIO');
    case 'morno':
      return t('REAL_ESTATE_BROKER_INVESTMENT.TEMPERATURES.MORNO');
    case 'quente':
      return t('REAL_ESTATE_BROKER_INVESTMENT.TEMPERATURES.QUENTE');
    default:
      return t('REAL_ESTATE_BROKER_INVESTMENT.TABLE.NOT_INFORMED');
  }
};

export const createRealEstateBrokerInvestmentPresenter = t => ({
  money: value =>
    formatBRL(value?.amount, {
      fallback: t('REAL_ESTATE_BROKER_INVESTMENT.TABLE.NOT_INFORMED'),
      fractionDigits: 2,
    }),
  temperatureLabel: temperature => temperatureLabel(t, temperature),
  temperatureClass: temperature =>
    ({
      frio: 'bg-violet-100 text-violet-700',
      morno: 'bg-slate-200 text-slate-700',
      quente: 'bg-red-100 text-red-700',
    })[temperature] || 'bg-slate-100 text-slate-700',
  temperatureIcon: temperature =>
    ({
      frio: 'i-lucide-snowflake',
      morno: 'i-lucide-cloud-sun',
      quente: 'i-lucide-flame',
    })[temperature] || 'i-lucide-circle-help',
  address: row =>
    [row?.logradouro, row?.numero].filter(Boolean).join(', ') ||
    t('REAL_ESTATE_BROKER_INVESTMENT.TABLE.ADDRESS_UNAVAILABLE'),
  addressDetail: row => {
    const unit = [row?.unidade, row?.complemento].filter(Boolean).join(' / ');

    return [unit, row?.bairro].filter(Boolean).join(' - ');
  },
  date: value => {
    if (!value) return t('REAL_ESTATE_BROKER_INVESTMENT.TABLE.NOT_INFORMED');

    return new Intl.DateTimeFormat('pt-BR').format(new Date(value));
  },
});
